import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getComponentSimilarity = api(async function getComponentSimilarity({
    projectId,
    taskId,
    title,
    content,
    search,
    showAvailable = true,
    showLocked = true,
    skip = 0,
    take = 20,
} = {}) {
    if (!projectId || (!taskId && !title && !content)) return null
    return query(
        gql`
            query GetComponentSimilarity(
                $projectId: String!
                $taskId: String
                $title: String
                $content: String
                $search: String
                $showAvailable: Boolean
                $showLocked: Boolean
                $skip: Int
                $take: Int
            ) {
                getComponentSimilarity(
                    projectId: $projectId
                    taskId: $taskId
                    title: $title
                    content: $content
                    search: $search
                    showAvailable: $showAvailable
                    showLocked: $showLocked
                    skip: $skip
                    take: $take
                ) {
                    totalCount
                    availableCount
                    lockedCount
                    availableScheduleTaskCounts {
                        scheduleId
                        taskCount
                    }
                    items {
                        id
                        task {
                            id
                            title
                            classification
                            content
                            note
                            taskId
                            frequency {
                                period
                                interval
                                label
                            }
                            skillSet
                            minutes
                        }
                        scheduleId
                        taskId
                        fullStrength
                        scheduleTitle
                        scheduleCode
                        lock {
                            locked
                            projectId
                            projectName
                        }
                    }
                }
            }
        `,
        {
            projectId,
            taskId,
            title,
            content,
            search,
            showAvailable,
            showLocked,
            skip,
            take,
        },
        { returns: "getComponentSimilarity" }
    )
})
